<template>
  <div>
    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-radio-group v-model="v.role.$model" row :disabled="disabled">
            <v-radio label="Физическое лицо" :value="Role.PERSON" />
            <v-radio label="Юридическое лицо" :value="Role.ORGANIZATION" />
            <v-radio
              label="Иностранное юридическое лицо"
              :value="Role.FOREIGN_ORGANIZATION"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <Person
      v-if="v.role.$model === Role.PERSON"
      :v="v.person"
      :disabled="disabled"
      @change-reason="$emit('change-reason', $event)"
      translationKey="noticeRecovery.creditor.person"
    />

    <Organization
      v-if="v.role.$model === Role.ORGANIZATION"
      :v="v.organization"
      :disabled="disabled"
      @change-reason="$emit('change-reason', $event)"
      translationKey="noticeRecovery.creditor.org"
    />

    <ForeignOrganization
      v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
      :v="v.foreignOrganization"
      :disabled="disabled"
      @change-reason="$emit('change-reason', $event)"
      translationKey="noticeRecovery.creditor.foreignOrg"
    />

    <div v-if="canDelete" class="py-6">
      <v-btn
        depressed
        color="primary"
        class="button-base"
        @click="$emit('delete')"
      >
        Удалить
      </v-btn>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { Role } from '@/utils/dictionaries';
import Organization, {
  organizationModel,
  getOrganizationValidation,
} from './Organization.vue';
import Person, { personModel, getPersonValidation } from './Person.vue';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from './ForeignOrganization.vue';

export const creditorModel = {
  role: Role.PERSON,
  [Role.PERSON]: cloneDeep(personModel),
  [Role.ORGANIZATION]: cloneDeep(organizationModel),
  [Role.FOREIGN_ORGANIZATION]: cloneDeep(foreignOrganizationModel),
};

export const getCreditorValidation = (applicant) => ({
  role: {},
  person: getPersonValidation(applicant),
  organization: getOrganizationValidation(applicant),
  foreignOrganization: cloneDeep(foreignOrganizationValidation),
});

export default {
  name: 'Creditor',
  components: { Organization, Person, ForeignOrganization },
  props: {
    v: Object,
    canDelete: Boolean,
    disabled: Boolean,
  },
  data: () => ({
    Role,
  }),
  computed: {
    role() {
      return this.v.role.$model;
    },
  },
  watch: {
    role(role) {
      this.$emit('change-reason', this.v[role].changeReason.$model);
    },
  },
};
</script>

<style scoped></style>
